import { render, staticRenderFns } from "./CMOverviewExpandedItem.vue?vue&type=template&id=c8ac79de&scoped=true&lang=pug"
import script from "./CMOverviewExpandedItem.vue?vue&type=script&lang=js"
export * from "./CMOverviewExpandedItem.vue?vue&type=script&lang=js"
import style0 from "./CMOverviewExpandedItem.vue?vue&type=style&index=0&id=c8ac79de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ac79de",
  null
  
)

export default component.exports